<section class="personal_info_sec">
  <div class="custom-tabs">

    <div>

    <div class="basic-info-header">
      <h3 class="section-title">Basic Info</h3>
    
      <button *ngIf="token.type !== 'ADMIN'" class="btn btn-sm" (click)="openModal()">
        Delete My Account
      </button>
    </div>

    <div class="modal-backdrop-custom" *ngIf="showDeleteModal">
      <div class="modal-dialog-custom">
        <div class="modal-content">
    
          <div class="modal-header">
            <h5 class="modal-title">Delete Account</h5>
            <button type="button" class="close" (click)="closeModal()">
              <span>&times;</span>
            </button>
          </div>
    
          <div class="modal-body">
            <p>We’re sorry to see you go.</p>
            <!-- <p>We’re sorry to see you go. Please tell us why you’re deleting your account. This helps us improve.</p> -->
    
            <!-- <div class="form-group">
                  <label for="reasonSelect">Reason</label>
                  <select id="reasonSelect"
                          class="form-control"
                          [(ngModel)]="selectedReason">
                    <option value="" disabled>Select a reason</option>
                    <option value="I no longer need the service">I no longer need the service</option>
                    <option value="Too expensive">Too expensive</option>
                    <option value="Switching to another platform">Switching to another platform</option>
                    <option value="Not enough features">Not enough features</option>
                    <option value="Technical issues">Technical issues</option>
                    <option value="Privacy or security concerns">Privacy or security concerns</option>
                    <option value="Created a duplicate account">Created a duplicate account</option>
                    <option value="Other">Other</option>
                  </select>
                </div> -->
    
            <textarea class="form-control mt-2" placeholder="Type your reason..." rows="3"
              *ngIf="selectedReason === 'Other'" [(ngModel)]="otherReason"></textarea>
          </div>
    
          <div class="modal-footer modal-footer-responsive">
            <button class="btn btn-danger" (click)="submitDelete()">Submit & Delete Account</button>
            <button class="btn btn-secondary" (click)="closeModal()">Cancel</button>
          </div>
    
        </div>
      </div>
    </div>

      <div class="underline-wrapper">
        <div class="underline-orange"></div>
        <div class="underline-grey"></div>
      </div>

      <!-- Basic Info -->


      <section class="tabs-body personal_details_tabbody">
        <!-- <app-profile></app-profile> -->
        <!-- PROFILE-IMAGES -->
        <div class="profile_data" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
          fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="15px">

          <div class="column profile_col" fxFlex.xl="65" fxFlex.lg="65" fxFlex.md="65" fxFlex.sm="65" fxFlex.xs="100"
            fxFlexFill *ngIf="token?.type !=='PROFESSIONAL'">
            <span class="avatar_label">Business Logo</span>
            <div class="avatar-upload">
              <div class="avatar-edit">
                <input type='file' id="imageUpload" accept=".png, .jpg, .jpeg"
                  (change)="onSelectFileDp(fileVable.files)" #fileVable (click)="$event.stopPropagation()" />
                <label for="imageUpload"></label>
                <!-- <mat-progress-spinner [diameter]="25" [value]="progress" *ngIf="progress > 0">
                  </mat-progress-spinner> -->
              </div>
              <div class="avatar-preview">

                <div id="imagePreview">
                  <img *ngIf="!userDisplay?.logo"
                    src="../../../../../assets/images/empty-imgs/business_logo_placeholder.svg" alt="img" />
                  <img *ngIf="userDisplay?.logo"
                    onerror='this.onerror=null;this.src="../../../../../assets/images/empty-imgs/business_logo_placeholder.svg";'
                    [src]="userDisplay?.logo?.url" alt="img" />
                </div>

              </div>
            </div>
          </div>
        </div>
        <form [formGroup]="subscriberDetailForm" class="form-section" *ngIf="token?.type !=='PROFESSIONAL'">
          <div class="personal_details_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
            fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="50px">
            <div class="personal_details_column mobile_mb_0" fxLayout="column" fxFlex.xl="30" fxFlex.lg="30"
              fxFlex.md="30" fxFlex.sm="30" fxFlex.xs="100" fxFlexFill>
              <!-- Select type-INPUT -->
              <div class="custom-form-group ">
                <label class="custom-label" for="">Business Name<span class="star"
                    style="display: inline-block !important;">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter business name" formControlName="businessName" (keypress)="allowOnlyCharacters($event)">
                    <!-- <mat-error *ngIf="businessName?.invalid && ( businessName?.dirty || businessName?.touched )">
                        <span>Business name is
                          required</span>
                      </mat-error> -->
                    <mat-error
                      *ngIf="subscriberDetailForm.get('businessName')?.hasError('required') 
                   && (subscriberDetailForm.get('businessName')?.touched || subscriberDetailForm.get('businessName')?.dirty)">
                      Business name is
                      required
                    </mat-error>

                  </mat-form-field>
                </div>
              </div>



            </div>
            <div class="personal_details_column mobile_mb_0" fxLayout="column" fxFlex.xl="30" fxFlex.lg="30"
              fxFlex.md="30" fxFlex.sm="30" fxFlex.xs="100" fxFlexFill>
              <!-- First Name -->
              <form [formGroup]="signUpDetailsForm" class="form-section" *ngIf="token?.type !=='PROFESSIONAL'">
                <div class="custom-form-group">
                  <label class="custom-label" for="">Contact Name<span class="star"
                      style="display: inline-block !important;">*</span></label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input matInput placeholder="Enter your contact name" formControlName="name">
                      <mat-icon matSuffix class="profile_edit" (click)="openFieldName()">
                        <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                      </mat-icon>

                      <mat-error *ngIf="signUpDetailsForm.get('name')?.hasError('required') 
                   && (signUpDetailsForm.get('name')?.touched || signUpDetailsForm.get('name')?.dirty)">
                        Contact name is
                        required
                      </mat-error>

                      <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                      <!-- <mat-error *ngIf="fName.invalid && ( fName.dirty || fName.touched )"> <span>First name is
                          required</span>
                      </mat-error> -->
                    </mat-form-field>
                  </div>
                </div>
              </form>


            </div>
          </div>

        </form>
        <form [formGroup]="signUpDetailsForm" class="form-section">
          <div class="personal_details_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
            fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="50px">
            <div class="personal_details_column mobile_mb_0" fxLayout="column" fxFlex.xl="30" fxFlex.lg="30"
              fxFlex.md="30" fxFlex.sm="30" fxFlex.xs="100" fxFlexFill>
              <!-- Select type-INPUT -->
              <div class="custom-form-group" *ngIf="token?.type ==='PROFESSIONAL'">
                <label class="custom-label" for="">Name<span class="star"
                    style="display: inline-block !important;">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter your name" formControlName="name" (keypress)="allowOnlyCharacters($event)">
                    <mat-icon matSuffix class="profile_edit" (click)="openFieldName()">
                      <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                    </mat-icon>

                    <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                    <!-- <mat-error *ngIf="fName.invalid && ( fName.dirty || fName.touched )"> <span>First name is
                          required</span>
                      </mat-error> -->
                  </mat-form-field>
                </div>
              </div>

              <form [formGroup]="subscriberDetailForm" class="form-section" *ngIf="token?.type !=='PROFESSIONAL'">
                <div class="custom-form-group " *ngIf="token?.type =='SUPPLIER' || token?.type =='PRACTICE'">
                  <label class="custom-label" for="">ABN / ACN Number<span class="star"
                      style="display: inline-block !important;">*</span></label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input matInput placeholder="Enter abn/acn Name" formControlName="ABN_ACN_number" maxlength="10" (keypress)="allowOnlyNumbers($event)">
                      <!-- <mat-error
                        *ngIf="ABN_ACN_number?.invalid && ( ABN_ACN_number?.dirty || ABN_ACN_number?.touched )">
                        <span>ABN / ACN number is
                          required</span>
                      </mat-error> -->

                      <mat-error
                        *ngIf="subscriberDetailForm.get('ABN_ACN_number')?.hasError('required') 
                   && (subscriberDetailForm.get('ABN_ACN_number')?.touched || subscriberDetailForm.get('ABN_ACN_number')?.dirty)">
                        ABN / ACN number is
                        required
                      </mat-error>

                    </mat-form-field>
                  </div>
                </div>
              </form>

              <form [formGroup]="professionalDetailsForm" class="form-section" *ngIf="token?.type !=='PROFESSIONAL'">
                <div class="custom-form-group">

                  <label class="custom-label" for="">Business Type<span class="star"
                      style="display: inline-block !important;">*</span></label>
                  <div class="custom-form-control" style="position: relative;">
                    <mat-form-field appearance="outline">
                      <input matInput readonly placeholder="Select business type" formControlName="profession_type">
                    </mat-form-field>

                    <div style=" position: absolute !important;right: 17px !important;top: 11px;"
                      (click)="selectProfessionType()" class="iconarrow">
                      <svg width=" 15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.75 1L7.5 7.25L1.25 1" stroke="black" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                    </div>

                  </div>
                </div>
              </form>

              <div class="custom-form-group" *ngIf="token?.type ==='PROFESSIONAL'">
                <label class="custom-label" for="">Phone No<span class="star"
                    style="display: inline-block !important;">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter your phone number" maxlength="10" formControlName="phone"
                      (keypress)="allowOnlyNumbers($event)">
                    <mat-icon matSuffix class="profile_edit" (click)="openField()">
                      <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                    </mat-icon>
                    <mat-error *ngIf="phone.hasError('required') && (phone.dirty || phone.touched)">
                      Phone No is required
                    </mat-error>
                    <mat-error *ngIf="phone.hasError('pattern') && (phone.dirty || phone.touched)">
                      Enter a valid 10-digit phone number
                    </mat-error>

                  </mat-form-field>
                </div>
              </div>


            </div>
            <div class="personal_details_column mobile_mb_0" fxLayout="column" fxFlex.xl="30" fxFlex.lg="30"
              fxFlex.md="30" fxFlex.sm="30" fxFlex.xs="100" fxFlexFill>
              <!-- First Name -->
              <div class="custom-form-group">
                <label class="custom-label" for="">Email<span class="star"
                    style="display: inline-block !important;">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input type="email" matInput placeholder="Enter your email" readonly formControlName="email">
                    <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                    <!-- <mat-error *ngIf="email.invalid && ( email.dirty || email.touched )"> <span>Email is
                          required</span>
                      </mat-error> -->
                  </mat-form-field>
                </div>
              </div>

              <form [formGroup]="signUpDetailsForm" class="form-section" *ngIf="token?.type !=='PROFESSIONAL'">

                <div class="custom-form-group">
                  <label class="custom-label" for="">Phone No<span class="star"
                      style="display: inline-block !important;">*</span></label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input matInput placeholder="Enter your phone number" maxlength="10" formControlName="phone"
                        (keypress)="allowOnlyNumbers($event)">
                      <mat-icon matSuffix class="profile_edit" (click)="openField()">
                        <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                      </mat-icon>
                      <mat-error *ngIf="phone.hasError('required') && (phone.dirty || phone.touched)">
                        Phone No is required
                      </mat-error>
                      <mat-error *ngIf="phone.hasError('pattern') && (phone.dirty || phone.touched)">
                        Enter a valid 10-digit phone number
                      </mat-error>

                    </mat-form-field>
                  </div>
                </div>
              </form>


            </div>
          </div>

        </form>
      
      </section>

    </div>

    <div *ngIf="token?.type ==='PROFESSIONAL'">
      <h3 class="section-title">Personal Details </h3>

      <div class="underline-wrapper">
        <div class="underline-orange"></div>
        <div class="underline-grey"></div>
      </div>


      <!-- Personal Details  -->
      <section class="tabs-body personal_details_tabbody">
        <!-- <app-profile></app-profile> -->
        <!-- PROFILE-IMAGES -->
        <div class="profile_data" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
          fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="15px">
          <div class="column" fxFlex.xl="65" fxFlex.lg="65" fxFlex.md="65" fxFlex.sm="65" fxFlex.xs="100" fxFlexFill
            *ngIf="token?.type =='PROFESSIONAL'">
            <span>Image</span>
            <div class="avatar-upload">
              <div class="avatar-edit">
                <input type='file' id="imageUpload" accept=".png, .jpg, .jpeg"
                  (change)="onSelectFileDp(fileVable.files)" #fileVable (click)="$event.stopPropagation()" />
                <label for="imageUpload"></label>
                <!-- <mat-progress-spinner [diameter]="25" [value]="progress" *ngIf="progress > 0">
                  </mat-progress-spinner> -->
              </div>
              <div class="avatar-preview">


                <div id="imagePreview">
                  <img *ngIf="!userDisplay?.profile_image"
                    src="../../../../../assets/images/empty-imgs/empty-user-image.png" />
                  <img *ngIf="userDisplay?.profile_image"
                    onerror='this.onerror=null;this.src="../../../../../assets/images/empty-imgs/empty-user-image.png";'
                    [src]="userDisplay?.profile_image?.url"/>
                </div>

              </div>
              <!-- <mat-error *ngIf="!userDisplay?.profile_image && profileImageRequired">
    Profile image is required.
  </mat-error> -->
            </div>
          </div>

        </div>
        <form [formGroup]="subscriberDetailForm" class="form-section">
          <div class="personal_details_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
            fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="50px">
            <div *ngIf="token?.type !=='SUPPLIER' && token?.type !=='PRACTICE'"
              class="personal_details_column mobile_mb_0" fxLayout="column" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30"
              fxFlex.sm="30" fxFlex.xs="100" fxFlexFill>
              <!-- Select type-INPUT -->
              <div class="custom-form-group" *ngIf="token?.type !=='SUPPLIER' && token?.type !=='PRACTICE'">
                <label class="custom-label" for="">Select type<span class="star"
                    style="display: inline-block !important;">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <mat-select placeholder="Select any type" formControlName="salutation">
                      <!-- <mat-select placeholder="Select any type" [disabled]="butDisabled" formControlName="salutation"> -->
                      <mat-option disabled=""> Select gender </mat-option>
                      <mat-option [value]="'Mr'">Mr.</mat-option>
                      <mat-option [value]="'Mrs'">Mrs.</mat-option>
                      <mat-option [value]="'Ms'">Ms.</mat-option>
                      <mat-option [value]="'Dr'">Dr.</mat-option>
                    </mat-select>
                    <!-- <mat-error *ngIf="salutation.invalid && ( salutation.dirty || salutation.touched )">
                      <span>Please provide a valid type</span>
                    </mat-error> -->
                    <mat-error *ngIf="subscriberDetailForm.get('salutation')?.hasError('required')">
                      Type is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <!-- Middle Name -->
              <div class="custom-form-group" *ngIf="token?.type !=='SUPPLIER' && token?.type !=='PRACTICE'">
                <label class="custom-label" for="">Middle Name<span class="star">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter middle name" formControlName="middle_name"
                      (keypress)="allowOnlyCharacters($event)">
                    <!-- <input matInput placeholder="Enter middle Name" readonly formControlName="middle_name"> -->
                    <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                    <!-- <mat-error *ngIf="fName.invalid && ( fName.dirty || fName.touched )"> <span>First name is
                          required</span>
                      </mat-error> -->
                  </mat-form-field>
                </div>
              </div>
              <!-- Date of Birth -->
              <div class="custom-form-group" *ngIf="token?.type !=='SUPPLIER' && token?.type !=='PRACTICE'">
                <label class="custom-label" for="">Date of Birth
                  <span class="star" style="display: inline-block !important;">*</span>
                </label>
                <div class="custom-form-control">
                   <mat-form-field appearance="outline">
                    <input matInput placeholder="DD/MM/YYYY" [matDatepicker]="picker"
                      formControlName="date_of_birth" [max]="maxDOB">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error *ngIf="subscriberDetailForm.get('date_of_birth')?.hasError('required')">
                      DOB is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div *ngIf="token?.type !=='SUPPLIER' && token?.type !=='PRACTICE'"
              class="personal_details_column mobile_mb_0" fxLayout="column" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30"
              fxFlex.sm="30" fxFlex.xs="100" fxFlexFill>
              <!-- First Name -->
              <div class="custom-form-group" *ngIf="token?.type !=='SUPPLIER' && token?.type !=='PRACTICE'">
                <label class="custom-label" for="">First Name<span class="star"
                    style="display: inline-block !important;">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter first name" readonly formControlName="name">
                    <!-- <mat-icon matSuffix>
                                            <img src="../../../../../assets/images/icons/check.svg" alt="">
                                          </mat-icon> -->
                    <!-- <mat-error *ngIf="fName.invalid && ( fName.dirty || fName.touched )"> <span>First name is
                                            required</span>
                                        </mat-error> -->
                    <mat-error *ngIf="subscriberDetailForm.get('name')?.hasError('required')">
                      Name is required
                    </mat-error>

                  </mat-form-field>
                </div>
              </div>
              <!-- Last Name -->
              <div class="custom-form-group" *ngIf="token?.type !=='SUPPLIER' && token?.type !=='PRACTICE'">
                <label class="custom-label" for="">Last Name<span class="star"
                    style="display: inline-block !important;">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter last name" formControlName="last_name"
                      (keypress)="allowOnlyCharacters($event)">
                    <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                    <!-- <mat-error *ngIf="last_name?.invalid && ( last_name.dirty || last_name.touched )"> <span>Last name is
                          required</span>
                      </mat-error> -->
                    <mat-error *ngIf="subscriberDetailForm.get('last_name')?.hasError('required')">
                      Last name is required
                    </mat-error>

                  </mat-form-field>
                </div>
              </div>
              <!-- Gender -->
              <div class="custom-form-group">
                <label class="custom-label" for="">Gender
                  <span class="star" style="display: inline-block !important;">*</span>
                </label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <mat-select placeholder="Select any type" formControlName="gender">
                      <!-- <mat-select placeholder="Select any type" [disabled]="butDisabled" formControlName="gender"> -->
                      <mat-option disabled=""> Select gender </mat-option>
                      <mat-option [value]="'male'">Male</mat-option>
                      <mat-option [value]="'female'">Female</mat-option>
                      <mat-option [value]="'other'">Other</mat-option>
                    </mat-select>
                    <!-- <mat-error *ngIf="gender.invalid && ( gender.dirty || gender.touched )">
                          <span>Please provide a valid value</span>
                        </mat-error> -->
                    <mat-error *ngIf="subscriberDetailForm.get('gender')?.hasError('required')">
                      Gender is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <!-- Email-INPUT -->
              <!-- Password-INPUT -->
              <!-- <div class="custom-form-group">
                  <label class="custom-label" for="">Password<span class="star">*</span></label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input matInput placeholder="Enter Password" formControlName="password">
                      <mat-icon matSuffix>
                        <img src="../../../../../assets/images/icons/check.svg" alt="">
                      </mat-icon>
                      <mat-error *ngIf="password.invalid && ( password.dirty || password.touched )">
                        <span>Password is required</span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div> -->
            </div>
          </div>
          <div class="personal_details_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
            fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="50px">
            <div *ngIf="token?.type =='SUPPLIER' || token?.type =='PRACTICE'"
              class="personal_details_column mobile_mb_0" fxLayout="column" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30"
              fxFlex.sm="30" fxFlex.xs="100" fxFlexFill>

            </div>

            <!-- PHone No-INPUT -->
            <!-- <div class="custom-form-group">
                  <label class="custom-label" for="">Phone No<span class="star">*</span></label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input type="number" matInput placeholder="Enter Phone No" formControlName="phone">
                      <mat-icon matSuffix>
                        <img src="../../../../../assets/images/icons/check.svg" alt="">
                      </mat-icon>
                      <mat-error *ngIf="phone.invalid && ( phone.dirty || phone.touched )"> <span>Phone No is
                          required</span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div> -->
            <!-- Confirm-Password-INPUT -->
            <!-- <div class="custom-form-group">
                  <label class="custom-label" for="">Confirm Password<span class="star">*</span></label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input matInput placeholder="Enter Confirm Password" formControlName="confirmPassword">
                      <mat-icon matSuffix>
                        <img src="../../../../../assets/images/icons/check.svg" alt="">
                      </mat-icon>
                      <mat-error
                        *ngIf="confirmPassword.invalid && ( confirmPassword.dirty || confirmPassword.touched )">
                        <span>Confirm Password is required</span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div> -->
          </div>
        </form>
        <!-- <div class="" fxLayout="column" fxLayoutAlign="center center">
            <button class="btn btn-sm global-btn profile_save_btn" mat-button (click)="submitDetails()">Submit</button>
          </div> -->
      </section>

    </div>
    <div>
      <h3 class="section-title">Contact Information </h3>

      <div class="underline-wrapper">
        <div class="underline-orange"></div>
        <div class="underline-grey"></div>
      </div>


      <!-- Contact Information -->
      <section class="tabs-body">
        <form [formGroup]="contactInformationForm" class="form-section">
          <div class="contact_numbers" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
            fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="50px">
            <div class="column col_contacts mobile_mb_0" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="30"
              fxFlex.xs="100" fxFlexFill>
              <!-- Alternate email-INPUT -->

              <form [formGroup]="subscriberDetailForm" class="form-section">

                <div class="custom-form-group " *ngIf="token?.type =='SUPPLIER'|| token?.type =='PRACTICE'">
                  <label class="custom-label" for="">first name<span class="star"
                      style="display: inline-block !important;">*</span></label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input readonly matInput placeholder="Enter first name" formControlName="name">
                      <mat-error *ngIf="contactInformationForm.get('name')?.hasError('required') 
                   && (contactInformationForm.get('name')?.touched || contactInformationForm.get('name')?.dirty)">
                        Name is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

              </form>

              <div class="custom-form-group" *ngIf="token?.type =='SUPPLIER'|| token?.type =='PRACTICE'">
                <label class="custom-label" for="">last name<span class="star"
                    style="display: inline-block !important;">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter last name" formControlName="lName" (keypress)="allowOnlyCharacters($event)">
                    <mat-error *ngIf="contactInformationForm.get('lName')?.hasError('required') 
                   && (contactInformationForm.get('lName')?.touched || contactInformationForm.get('lName')?.dirty)">
                      Last name is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>


              <div class="custom-form-group" *ngIf="token?.type =='SUPPLIER'|| token?.type =='PRACTICE'">
                <label class="custom-label" for="">Alternate Phone number</label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input type="altPhone" matInput placeholder="Enter alternate phone number"
                      formControlName="altPhoneNo" maxlength="10" (keypress)="allowOnlyNumbers($event)">
                    <mat-icon matSuffix class="profile_edit" (click)="altPhone()">
                      <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                    </mat-icon>
                    <mat-error *ngIf="altPhoneNo?.hasError('pattern') && (altPhoneNo?.dirty || altPhoneNo?.touched)">
                      Please enter a valid phone number
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>





              <!-- <div class="custom-form-group">
                  <label class="custom-label" for="">Address<span class="star">*</span></label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input matInput placeholder="Enter address" formControlName="address">
                     
                    </mat-form-field>
                  </div>
                </div> -->

              <div class="custom-form-group custom-form-group-form">
                <label class="custom-label" for="">
                  Address<span class="star" style="display: inline-block !important;">*</span>
                </label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Search for location" formControlName="address" autocorrect="off"
                      autocapitalize="off" spellcheck="off" type="text" #addressSearch>

                    <!-- <input matInput placeholder="Enter address" formControlName="address" readonly> -->

                    <mat-error
                      *ngIf="contactInformationForm?.get('address')?.hasError('required') 
                   && (contactInformationForm?.get('address')?.touched || contactInformationForm?.get('address')?.dirty)">
                      Address is required
                    </mat-error>

                  </mat-form-field>
                </div>
              </div>

              <div class="custom-form-group">
                <label class="custom-label" for="">Address Line 2</label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <textarea matInput placeholder="Enter address line 2" readonly
                      formControlName="address_line_two"> </textarea>
                    <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                    <!-- <mat-error *ngIf="addLine2.invalid && ( addLine2.dirty || addLine2.touched )"> <span>Address
                            Line 2 is
                            required</span>
                        </mat-error> -->
                  </mat-form-field>
                </div>
              </div>

                <!-- landmark-INPUT -->
              <div class="custom-form-group">
                <label class="custom-label" for="">City</label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter city" readonly formControlName="city">
                    <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                    <!-- <mat-error *ngIf="city.invalid && ( city.dirty || city.touched )"> <span>City is required</span>
                        </mat-error> -->
                  </mat-form-field>
                </div>
              </div>

                 <div class="custom-form-group">
                <label class="custom-label" for="">Country</label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter country" readonly formControlName="country">
                    <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                    <!-- <mat-error *ngIf="country.invalid && ( country.dirty || country.touched )"> <span>Country is
                            required</span>
                        </mat-error> -->
                  </mat-form-field>
                </div>
              </div>
            
             
            </div>
            <div class="column col_contacts mobile_mb_0" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="30"
              fxFlex.xs="100" fxFlexFill>
              <div class="custom-form-group" *ngIf="token?.type =='SUPPLIER'|| token?.type =='PRACTICE'">
                <label class="custom-label" for="">middle name</label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter middle name" formControlName="mName" (keypress)="allowOnlyCharacters($event)">

                  </mat-form-field>
                </div>
              </div>
              <!-- <div class="custom-form-group" *ngIf="token?.type =='PRACTICE'">
                <label class="custom-label" for="">business email</label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter business email" formControlName="businessEmail">
                    <mat-icon matSuffix class="profile_edit" (click)="buzzEmail()">
                      <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                    </mat-icon>
                    <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon>
                    <mat-error *ngIf="landmark.invalid && ( landmark.dirty || landmark.touched )"> <span>Landmark is
                            required</span>
                        </mat-error>
                  </mat-form-field>
                </div>
              </div> -->

              <div class="custom-form-group" *ngIf="token?.type =='SUPPLIER'|| token?.type =='PRACTICE'">
                <label class="custom-label" for="">fax number</label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter fax number" formControlName="faxNumber">
                    <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                    <!-- <mat-error *ngIf="landmark.invalid && ( landmark.dirty || landmark.touched )"> <span>Landmark is
                            required</span>
                        </mat-error> -->
                  </mat-form-field>
                </div>
              </div>

              <!-- <div class="custom-form-group" *ngIf="token?.type =='SUPPLIER'|| token?.type =='PRACTICE'">
                  <label class="custom-label" for="">business phone number<span class="star">*</span></label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input matInput placeholder="Enter business phone number" formControlName="businessPhoneNumber" maxlength="10" (keypress)="allowOnlyNumbers($event)">
                      <mat-icon matSuffix class="profile_edit" (click)="buzzPhone()">
                        <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                      </mat-icon>
                      <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon>
                      <mat-error *ngIf="landmark.invalid && ( landmark.dirty || landmark.touched )"> <span>Landmark is
                            required</span>
                        </mat-error>
                    </mat-form-field>
                  </div>
                </div> -->


              <div class="custom-form-group" *ngIf="token?.type =='SUPPLIER'|| token?.type =='PRACTICE'">
                <label class="custom-label" for="">Alternate email<span class="star">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter alternate email" formControlName="altEmail">
                    <mat-icon matSuffix class="profile_edit" (click)="altMail()">
                      <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                    </mat-icon>
                    <mat-error *ngIf="altEmail?.hasError('pattern') && (altEmail?.dirty || altEmail?.touched)">
                      Please enter a valid email address
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <!-- Address Line 1-INPUT -->
              <div class="custom-form-group">
                <label class="custom-label" for="">Address Line 1</label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <textarea matInput readonly placeholder="Enter address line 1"
                      formControlName="address_line_one"> </textarea>
                    <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                    <!-- <mat-error *ngIf="addLine1.invalid && ( addLine1.dirty || addLine1.touched )"> <span>Address
                            Line 1 is
                            required</span>
                        </mat-error> -->
                  </mat-form-field>
                </div>
              </div>
            

                 <div class="custom-form-group">
                <label class="custom-label" for="">Landmark</label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter landmark" readonly formControlName="land_mark">
                    <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                    <!-- <mat-error *ngIf="landmark.invalid && ( landmark.dirty || landmark.touched )"> <span>Landmark is
                            required</span>
                        </mat-error> -->
                  </mat-form-field>
                </div>
              </div>
              <!-- state-INPUT -->
              <!-- Zip Code-INPUT -->
              <!-- Alternate Phone number-INPUT -->
              <!-- Address Line 2-INPUT -->
              <!-- city-INPUT -->
              <!-- country-INPUT -->
           

               <div class="custom-form-group">
                <label class="custom-label" for="">State</label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter state" readonly formControlName="state">
                    <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                    <!-- <mat-error *ngIf="state.invalid && ( state.dirty || state.touched )"> <span>State is
                            required</span>
                        </mat-error> -->
                  </mat-form-field>
                </div>
              </div>
              <div class="custom-form-group">
                <label class="custom-label" for="">Post Code</label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter post code" readonly formControlName="zipcode">
                    <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                    <!-- <mat-error *ngIf="zipCode.invalid && ( zipCode.dirty || zipCode.touched )"> <span>Zip Code is
                            required</span>
                        </mat-error> -->
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
              fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="0px"
              *ngIf="token?.type =='SUPPLIER'|| token?.type =='PRACTICE'">
              <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
                fxFlexFill>
                <div class="account_branch">
                  <div class="or">
                    <span>Secondary Contact Info</span>
                  </div>
                </div>
              </div>
            </div> -->
          <!-- <div class="second_contact" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
              fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="50px"
              *ngIf="token?.type =='SUPPLIER'|| token?.type =='PRACTICE'">
              <div class="column second_column mobile_mb_0" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="30"
                fxFlex.xs="100" fxFlexFill>
                <div class="custom-form-group">
                  <label class="custom-label" for="">Contact name</label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input matInput placeholder="Enter contact name" formControlName="contactName">
                      <mat-error *ngIf="contactName.invalid && ( contactName.dirty || contactName.touched )">
                        <span>Contact name is required</span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
   
                <div class="custom-form-group">
                  <label class="custom-label" for="">Phone Number</label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input matInput placeholder="Enter phone number" formControlName="phoneNoTwo">
                      <mat-error *ngIf="phoneNoTwo.invalid && ( phoneNoTwo.dirty || phoneNoTwo.touched )">
                        <span>Phone number is required</span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="column second_column mobile_mb_0" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="30"
                fxFlex.xs="100" fxFlexFill>
              
                <div class="custom-form-group">
                  <label class="custom-label" for="">Email Address</label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input matInput placeholder="Enter email address" formControlName="emailTwo">
                      <mat-error *ngIf="emailTwo.invalid && ( emailTwo.dirty || emailTwo.touched )">
                        <span>Email is required</span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div> -->
          <!-- <div class="submit_btn_row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
              fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="0px">
              <div class="submits_btns" fxFlex.xl="65" fxFlex.lg="65" fxFlex.md="65" fxFlex.sm="65" fxFlex.xs="100"
                fxFlexFill fxLayoutAlign="end end">
                <button (click)="changeContact()" class="btn btn-sm global-btn profile_save_btn">Submit</button>
              </div>
            </div>
            <div class="" fxLayout="column" fxLayoutAlign="center center">
              </div> -->
        </form>
      </section>


    </div>
    <div *ngIf="token?.type === 'PROFESSIONAL'">
      <h3 class="section-title">Professional Details </h3>

      <div class="underline-wrapper">
        <div class="underline-orange"></div>
        <div class="underline-grey"></div>
      </div>
      <!-- Professional Details -->
      <section class="tabs-body">
        <form [formGroup]="professionalDetailsForm" class="form-section">
          <div class="flex-wrap professional_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
            fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="50px">
            <div class="column professional_column mobile_mb_0" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30"
              fxFlex.sm="30" fxFlex.xs="100" fxFlexFill>
              <!-- Profession Type-SELECT -->
              <div class="custom-form-group">
                <label class="custom-label" for="">Profession Type<span class="star"
                    style="display: inline-block !important;">*</span></label>
                <div class="custom-form-control" style="position: relative;">
                  <mat-form-field appearance="outline">
                    <input matInput readonly placeholder="Select profession type" formControlName="profession_type">
                  </mat-form-field>

                  <div style=" position: absolute !important;right: 17px !important;top: 11px;"
                    (click)="selectProfessionType()" class="iconarrow">
                    <svg width=" 15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.75 1L7.5 7.25L1.25 1" stroke="black" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </div>

                </div>
              </div>

              <!-- APHRA Registration Number-INPUT -->
              <div class="custom-form-group" *ngIf="token?.type =='PROFESSIONAL'|| token?.type =='PRACTICE'">
                <label class="custom-label" for="">APHRA Registration Number</label>
                <div class="custom-form-control">



                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter aphra registration number"
                      formControlName="pro_details_aphra_registration_number" maxlength="13" minlength="13"
                      (keypress)="allowOnlyNumbers($event)">

                    <!-- Min Length Error -->
                    <mat-error
                      *ngIf="pro_details_aphra_registration_number?.hasError('minlength') && (pro_details_aphra_registration_number.dirty || pro_details_aphra_registration_number.touched)">
                      Must be 13 digits
                    </mat-error>

                    <!-- Max Length Error -->
                    <mat-error
                      *ngIf="pro_details_aphra_registration_number?.hasError('maxlength') && (pro_details_aphra_registration_number.dirty || pro_details_aphra_registration_number.touched)">
                      Must be 13 digits
                    </mat-error>
                  </mat-form-field>


                </div>
              </div>
            </div>

          </div>

          <!-- <div fxLayout="row" fxLayoutAlign="center center" style="margin-top: 20px;">
              <button mat-button color="primary" class="btn global-btn" (click)="submitProfessionalDetails()">
                Submit
              </button>
            </div> -->
        </form>
      </section>

    </div>
    <!-- <div>
        <h3 class="section-title">Other Info </h3>

        <div class="underline-wrapper">
          <div class="underline-orange"></div>
          <div class="underline-grey"></div>
        </div>

      
        <section class="tabs-body">
          <form [formGroup]="otherDetailsForm" class="form-section">
            <div class="sell-header">
              <div class="custom-slide-toggle" *ngIf="token?.type =='SUPPLIER'">
                <span>Dou you want to sell supplies</span>
                <mat-slide-toggle formControlName="sellProducts"></mat-slide-toggle>
              </div>
              <div class="custom-slide-toggle">
                <span>Dou you want to sell 2nd Hand supplies</span>
                <mat-slide-toggle [(ngModel)]="userDisplay.second_hand"
                  formControlName="sellSecondHandSupplies"></mat-slide-toggle>
              </div>
            </div>
            <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
              *ngIf="userDisplay?.second_hand" fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="0px">
              <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
                fxFlexFill>
                <div class="account_branch">
                  <div class="or">
                    <span>Bank Details</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="account_row" *ngIf="userDisplay?.second_hand" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row"
              fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="center stretch"
              fxLayoutGap="50px">
              <div class="column account_col" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="30"
                fxFlex.xs="100" fxFlexFill>
                <div class="custom-form-group">
                  <label class="custom-label" for="">Bank Name<span class="star">*</span></label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input matInput placeholder="Enter Bank Name" formControlName="bank_name">
                      <mat-icon matSuffix class="profile_edit" (click)="bankOne()">
                        <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                      </mat-icon>
              
                    </mat-form-field>
                  </div>
                </div>
                <div class="custom-form-group">
                  <label class="custom-label" for="">Account Number<span class="star">*</span></label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input matInput placeholder="Enter Account Number" formControlName="account_number">
                      <mat-icon matSuffix class="profile_edit" (click)="bankThree()">
                        <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                      </mat-icon>
                  
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="column account_col" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="30"
                fxFlex.xs="100" fxFlexFill>
                <div class="custom-form-group">
                  <label class="custom-label" for="">Account Holder Name<span class="star">*</span></label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input matInput placeholder="Enter Account Holder Name" formControlName="account_holder_name">
                      <mat-icon matSuffix class="profile_edit" (click)="bankTwo()">
                        <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                      </mat-icon>
                 
                    </mat-form-field>
                  </div>
                </div>
                <div class="custom-form-group">
                  <label class="custom-label" for="">BSB<span class="star">*</span></label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input matInput placeholder="Enter BSB" formControlName="bsb">
                      <mat-icon matSuffix class="profile_edit" (click)="bankFour()">
                        <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                      </mat-icon>
                     
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div fxLayout="row" *ngIf="userDisplay?.second_hand" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
              fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="0px">
              <div class="submits_btns" fxFlex.xl="65" fxFlex.lg="65" fxFlex.md="65" fxFlex.sm="65" fxFlex.xs="100"
                fxFlexFill fxLayoutAlign="end end">
                <button (click)="changeBank()" class="btn btn-sm global-btn profile_save_btn" mat-button
                  [disabled]="bankOneBlock">Submit</button>
              </div>
            </div>
          </form>
        </section>

      </div> -->




  </div>
  <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
    fxLayoutAlign="center stretch" fxLayoutGap="0px">
    <div class="submits_btns" fxFlex.xs="100" fxFlexFill fxLayoutAlign="end end">
      <button (click)="submitAllDetails()" class="btn btn-sm global-btn profile_save_btn" mat-button>Save &
        Update</button>
    </div>
  </div>
</section>